






































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tooltip
} from 'element-ui';

// gql
import FetchOrganizationStaffs from '@/graphql/queries/FetchOrganizationStaffs.gql';
import followShipmentMutation from '@/graphql/mutations/FollowShipment.gql';
import unfollowShipmentMutation from '@/graphql/mutations/UnfollowShipment.gql';

// types
import {
  InquiryFields,
  organizationStaff_organizationStaff as Staff
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    members: {
      query: FetchOrganizationStaffs,
      variables() {
        return {
          organizationArgs: {
            customerOrganizationId: this.customerOrganization.id
          },
          pagination: {
            page: 1,
            per: 999 // all members
          }
        };
      },
      update(data) {
        return data?.organizationStaff || [];
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  components: {
    'el-button': Button,
    'el-dropdown': Dropdown,
    'el-dropdown-item': DropdownItem,
    'el-dropdown-menu': DropdownMenu,
    'el-tooltip': Tooltip
  }
})
export default class FollowShipment extends Vue {
  @Prop() public shipment!: InquiryFields;
  customerOrganization = this.shipment.customerOrganization;

  members: Staff[] = [];

  followers = this.shipment?.followers
    ? this.shipment.followers.map((follower) => follower.id)
    : [];

  following(id) {
    return this.followers.includes(id);
  }

  isLoading = false;

  async handleFollower(id: string) {
    if (!id) {
      return;
    }

    let mutation = followShipmentMutation;
    this.isLoading = true;

    if (this.following(id)) {
      mutation = unfollowShipmentMutation;
    }

    try {
      const response = await this.$apollo.mutate({
        mutation,
        variables: {
          shipmentId: this.shipment.id,
          shipperId: id
        }
      });

      if (response) {
        if (response.data.followShipment === true) {
          this.followers.push(id);
        } else if (response.data.unfollowShipment === true) {
          this.followers = this.followers.filter((followerId) => {
            return followerId !== id;
          });
        }
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.isLoading = false;
    }
  }
}
